import { Link } from "react-router-dom";

const ALIGN = {
  left: "left-0",
  center: "left-1/2 -translate-x-1/2",
  right: "right-0",
};

/** Internal route → <Link>, external/mailto → <a>. */
export function SmartLink({ to, href, children, ...rest }) {
  if (href) {
    const external = href.startsWith("http");
    return (
      <a href={href} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
}

/** Square line-icon tile that inverts on parent `group` hover. */
export function IconTile({ icon: Icon, size = "md" }) {
  const box = size === "sm" ? "h-7 w-7" : "h-8 w-8";
  return (
    <span
      className={`${box} shrink-0 inline-flex items-center justify-center rounded-sm border border-slate-200 bg-white text-topo group-hover:bg-topo group-hover:border-topo group-hover:text-white transition-colors duration-150`}
    >
      <Icon className="h-4 w-4" strokeWidth={1.75} />
    </span>
  );
}

/** Absolute dropdown container positioned under a nav item. */
export function DropdownShell({ align = "center", width, testid, children }) {
  return (
    <div className={`absolute top-full pt-3 z-50 ${ALIGN[align]}`} data-testid={testid}>
      <div className={`${width} bg-white border border-slate-200 shadow-2xl animate-in fade-in-0 slide-in-from-top-2 duration-200`}>
        {children}
      </div>
    </div>
  );
}
